import { render } from "./WorldCitySearch.vue?vue&type=template&id=580f9f7c"
import script from "./WorldCitySearch.vue?vue&type=script&lang=js"
export * from "./WorldCitySearch.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__